import { createStrictContext } from "@indietabletop/appkit";
import type { Knight } from "../engine/Knight";

export const [KnightContext, useKnight] = createStrictContext<Knight>();
